<template>
    <div class="allyesAdvWrap" v-if="ifShow">
        <div ref="ad"></div>
    </div>
</template>

<script>
export default {
    name: "advClass",
    props:['advCode','isDD','ddCode'],
    data(){
        return{
            advData:[],
            ddData:[],
            ifShow:true
        }
    },
    mounted() {
        let el = this.$refs['ad']
        this.renderAD(el)
    },
    methods:{
        renderAD(el) {
            fetch('https://show.artron.net/g?english='+this.advCode).then(r => r.text()).then(res => {
                let document = {
                    write: text => {
                        el.innerHTML += text
                        this.ifShow = text!=''?true:false
                    }
                }
                eval(res)
            })
        },
    }
}
</script>

<style scoped lang="scss">
.hotListAdv{margin-top: 20px;
    .first{
        a{height: 214px;display:block;background-color: #f2f2f2;display:flex;justify-content: center;align-items: center;position: relative;overflow: hidden;}
        img{width:100%;height:100%;object-fit: contain;}
        .hoverTxt{position: absolute;width:100%;height:100%;background-color: rgba(0,0,0,.65);display:flex;flex-direction:column;justify-content:center;color:#fff;font-size: 12px;line-height: 20px;top:100%;padding:0 40px;transition: .2s top ease-in-out;
            p{margin-bottom: 10px;}
            p:last-child{margin-bottom: 0;}
        }
    }
    //.first a:hover .hoverTxt{top:0;}
}
</style>